import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import Page from 'src/components/Page'
import PageHeader from 'src/components/page-header'
import DialogGift from 'src/views/giftshop/DialogGift'
import TableGiftUse from 'src/views/giftshop/TableGiftUse'

const GiftReqList = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [giftID, setGiftID] = useState(0);

  useEffect(() => {
    !showDrawer && setGiftID(0)
  }, [showDrawer])

  useEffect(() => {
    giftID > 0 && setShowDrawer(true)
  }, [giftID])

  return (
    <Page title="GiftReq">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                상품권 신청
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              상품권 신청 리스트를 보여줍니다.
            </Typography>
          }
        />
        <DialogGift show={showDrawer} setShow={setShowDrawer} giftID={giftID} />
        <Grid item xs={12}>
          <TableGiftUse setGiftID={setGiftID} />
        </Grid>
      </Grid>
    </Page>
  )
}

export default GiftReqList